const ROLES = {
	ADMINISTRATOR: "ADMINISTRATOR",
	USER: "USER",
}

export default ROLES;